module.exports = __webpack_public_path__ + "static/media/minus.f90f4b53.svg";